import React from "react";
import "./App.css";
import { useNavScrollHidden } from "./hooks/useNavScrollHidden";
import NavbarMenuButton from "./NavbarMenuButton";
import NavbarCloseButton from "./NavbarCloseButton";

const NAV_LINKS = [
  { href: "#about", label: "About", tone: "purple" },
  { href: "#experience", label: "Experience", tone: "blue" },
  { href: "#skills", label: "Skills", tone: "magenta" },
  { href: "#work", label: "Work", tone: "coral" },
];

function App(props) {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const [peekNav, setPeekNav] = React.useState(false);
  const { window: windowProp } = props;
  const scrollTarget =
    windowProp ? windowProp() : typeof window !== "undefined" ? window : null;
  const navHidden = useNavScrollHidden({
    threshold: 72,
    target: scrollTarget,
  });
  const showNav = !navHidden || peekNav;

  React.useEffect(() => {
    if (!navHidden) {
      setPeekNav(false);
    }
  }, [navHidden]);

  React.useEffect(() => {
    if (!mobileMenuOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [mobileMenuOpen]);

  const revealNav = () => {
    if (navHidden) {
      setPeekNav(true);
    }
  };

  const hideNavPeek = () => {
    if (navHidden) {
      setPeekNav(false);
    }
  };

  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <div className="navbar-app">
      <div
        className={`navbar-shell${navHidden ? " navbar-shell--scrolled" : ""}`}
        onMouseLeave={hideNavPeek}
      >
        <div
          className="navbar-reveal-zone"
          onMouseEnter={revealNav}
          aria-hidden="true"
        />
        <header
          id="navbar"
          className={showNav ? "navbar--visible" : "navbar--hidden"}
          onMouseEnter={revealNav}
        >
          <div className="navbar-toolbar">
            <a href="#top" className="navbar-brand">
              <span className="navbar-brand-mark" aria-hidden="true">
                JS
              </span>
              <span className="navbar-brand-text">Jas Sabharwal</span>
            </a>

            <nav className="navbar-nav" aria-label="Primary">
              {NAV_LINKS.map((link) => (
                <a key={link.href} href={link.href} className="navbar-link">
                  {link.label}
                </a>
              ))}
              <a href="#contact" className="navbar-link navbar-cta">
                Contact
              </a>
            </nav>

            <NavbarMenuButton
              open={mobileMenuOpen}
              ariaLabel="open menu"
              ariaControls="menu-mobile"
              onClick={() => setMobileMenuOpen(true)}
            />
          </div>
        </header>
      </div>

      <div
        className={
          "navbar-drawer-root" +
          (mobileMenuOpen ? " navbar-drawer-root--open" : "")
        }
        aria-hidden={!mobileMenuOpen}
      >
        <button
          type="button"
          className="navbar-drawer-backdrop"
          onClick={closeMobileMenu}
          tabIndex={mobileMenuOpen ? 0 : -1}
          aria-label="Close menu"
        />
        <aside
          id="menu-mobile"
          className="navbar-drawer-panel navbar-drawer-paper"
          role="dialog"
          aria-modal="true"
          aria-label="Navigation menu"
          aria-hidden={!mobileMenuOpen}
        >
          <div className="navbar-drawer">
            <div className="navbar-drawer-header">
              <a href="#top" className="navbar-brand" onClick={closeMobileMenu}>
                <span className="navbar-brand-mark" aria-hidden="true">
                  JS
                </span>
                <span className="navbar-brand-text">Jas Sabharwal</span>
              </a>
              <NavbarCloseButton onClick={closeMobileMenu} />
            </div>
            <nav className="navbar-drawer-nav">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className={`navbar-drawer-link navbar-drawer-link--${link.tone}`}
                  onClick={closeMobileMenu}
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#contact"
                className="navbar-drawer-link navbar-drawer-cta"
                onClick={closeMobileMenu}
              >
                Contact
              </a>
            </nav>
          </div>
        </aside>
      </div>
    </div>
  );
}

export default App;
